module.exports = "<igo-list [navigation]=\"false\"> \r\n  <ng-template ngFor let-tool [ngForOf]=\"tools\">\r\n    <igo-toolbar-item\r\n      igoListItem\r\n      color=\"accent\"\r\n      [withTitle]=\"withTitle\"\r\n      [withIcon]=\"withIcon\"\r\n      [tool]=tool\r\n      [selected]=\"selectedTool && selectedTool.name === tool.name\"\r\n      (select)=\"select.emit(tool)\"\r\n      (unselect)=\"unselect.emit(tool)\">\r\n    </igo-toolbar-item>\r\n  </ng-template>\r\n\r\n  <ng-content></ng-content>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/toolbar/toolbar.component.html
// module id = 956
// module chunks = 0